/* @jsxImportSource react */

import * as React from 'react';

const PriceValue = ({
  children,
  fixedTextClass,
  ...props
}: React.HTMLAttributes<Omit<HTMLSpanElement, 'className'>> & {
  // This is used as a workaround until EDS3 has a correct size variant for the product cards
  fixedTextClass?: string;
}) => (
  <span
    className={`price-value text-size-h4 ${fixedTextClass ?? 'group-[.price-size-small]:text-size-h6 lg:text-size-h3 lg:group-[.price-size-small]:text-size-h5'} inline-flex grow-0 items-center justify-start font-bold [grid-area:c]`}
    {...props}
  >
    {children}
  </span>
);

PriceValue.displayName = 'PriceValue';

export { PriceValue };
